@if (isInitialized && component) {
  <oe-chart [title]="component.alias" >
    <detailChart [isOnlyChart]="true"></detailChart>
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation [backButton]="true" [navigationOptions]="[]"></oe-footer-subnavigation>
}
